import React, { memo, ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectField } from '@bucketplace/commerce-admin-ui';

import {
  FormContent,
  InspectorFormProvider,
  LogDataFormGroup,
} from '../../../components';
import { useLinkContext } from '../../../contexts';
import { DocumentInspectorProps, DocumentNode } from '../../../types';
import { ImageMapShareProps } from './ImageMapShare';

const PLATFORM_OPTIONS = [
  {
    text: '카카오톡',
    value: 'kakaotalk',
  },
  {
    text: 'URL',
    value: 'url',
  },
];

export function ImageMapShareInspector({
  value,
  onChange,
}: DocumentInspectorProps<ImageMapShareProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <ImageMapShareForm value={value} />
      <LogDataInput
        value={value}
      />
    </InspectorFormProvider>
  );
}

function ImageMapShareForm({ value }: { value: DocumentNode<ImageMapShareProps> }): ReactElement {
  const { setValue } = useFormContext();
  const { style } = value?.props ?? {};

  useEffect(() => {
    setValue('style', style);
  }, [style, setValue]);

  return (
    <FormContent header="공유 플랫폼 선택">
      <SelectField
        name="platform"
        options={PLATFORM_OPTIONS}
      />
    </FormContent>
  );
}

const LogDataInput = memo(({ value }: { value: DocumentNode<ImageMapShareProps> }): ReactElement => {
  const { setLogData } = useLinkContext();
  const { children, ...others } = value ?? {};

  return (
    <LogDataFormGroup
      nodeKey={value?.key}
      {...setLogData?.({
        ...others,
        props: {
          logData: value?.props?.logData,
        },
      })}
    />
  );
});
